import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as shajs from 'sha.js';
import { UserAuthService } from '../../services/user-auth.service';
import { arrayAlert } from 'src/app/core/models/shared/alerts.interface';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/core/services/user.service';

@Component({
	selector: 'app-new-login',
	templateUrl: './new-login.component.html',
	styleUrls: ['./new-login.component.scss'],
})
export class NewLoginComponent implements OnInit {
	// ALERT SETTINGS
	public messageType: string = 'error';
	btnDisabled:boolean=false;

	public requiredAlert = [
		{
		title:'requerido',
		description:'Este campo es requerido'
		}
	]

	// Flag to track if the form has been submitted
	public formSubmitted = false;

	// Set mode
	mode: string;
	//? FORM ---------------------------------------------------------------------------------------------------------->
	public loginForm = this.fb.group({
		email: ['',
			[
				Validators.required,
				Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
			]
		],
		password: ['', [Validators.required]],
	});

	//! VALIDATIONS ---------------------------------------------------------------------------->
	isValidField(field:string):boolean {
		return this.loginForm.controls[field].errors && this.loginForm.controls[field].touched

	}

	public respError: boolean;

	arrayError:arrayAlert[] =  []



	//? CONSTRUCTOR
	constructor(
		private fb: FormBuilder,
		private router: Router,
		private userAuthService: UserAuthService,
		private ngZone: NgZone,
		private toast: ToastrService,
		private userService: UserAuthService,
		private dialog: MatDialog,
		private userSvc: UserService
	) {
	}

	//OnInit
	ngOnInit() {
		const openDialogs: MatDialogRef<any>[] = this.dialog.openDialogs;
		openDialogs.forEach((dialogRef: MatDialogRef<any>) => {
			dialogRef.close();
		});
		this.userService.getSystemVersion().then((res:any)=>{
			if(res.mensaje_return.ERROS_MENSAGGE ==='SUCCESS'){
				localStorage.setItem('version',res.version);
			}
		})
		localStorage.setItem('language','es');
		localStorage.setItem('mode','light');
	}
	get email() {
		return this.loginForm.get('email').value;
	}
	get password() {
		return shajs('sha512')
			.update(this.loginForm.get('password').value)
			.digest('hex');
	}


	//? LOGIN -------------------------------------------------------------------------------------------------------->
	async login() {
		if(this.loginForm.valid === true){
			const user = {
				user: this.email,
				pass: this.password,
			};
			this.userSvc.login(user).toPromise().then((resp: any) => {
				console.log('HOLA SOY EL LOIGIN ', resp);
				if(resp.mensaje_return.ERROR === true){
					this.mostrarErrorLoginInvalido();
				}
				else{
					localStorage.removeItem('data');
					localStorage.setItem('token', resp.token);
					localStorage.setItem('data', JSON.stringify(resp));
					localStorage.setItem('mode', 'light');
					this.userSvc.setData(resp);
					if (resp.result?.id_user_type && resp.result?.id_user) {
						localStorage.setItem('id_user_type',resp.result.id_user_type);
						localStorage.setItem('id_user', resp.result.id_user);
						if (resp.result.id_user_type === 7) {
							this.ngZone.run(() => this.router.navigateByUrl('/fetch/properties'))
						}
						else if (resp.result.id_user_type === 9) {
							this.ngZone.run(() => this.router.navigateByUrl('/admin/overview'));
						}
						else if (resp.result.id_user_type === 10) {
							this.ngZone.run(() => this.router.navigateByUrl('/ccc/orders'));
						}
						else if (resp.result.id_user_type ===11) {
							this.ngZone.run(() => this.router.navigateByUrl('/er/orders'));
						}
					}
					if (resp.data_company?.id_company) {
						localStorage.setItem('id_company',resp.data_company.id_company);
					}
					if (resp.result?.acronym_language) {
						localStorage.setItem('language',resp.result.acronym_language.toLowerCase());
					}
					if (resp.mensaje_return.ERROR) {
						console.error('Error logging in');
					}
					else {
						localStorage.setItem('token', resp.token);
						localStorage.setItem('data', JSON.stringify(resp));
						if (!localStorage.getItem('mode')) {
							localStorage.setItem('mode', this.mode);
						}
						this.userAuthService.setData(resp);
						if (resp.result?.id_user_type && resp.result?.id_user) {
							localStorage.setItem('user_type', resp.result.id_user_type);
							localStorage.setItem('id_user', resp.result.id_user);
						}
					}
				}
			})
		}
		else{
			let errorCount = 0;
			if(this.loginForm.get('email').value.length===0 || this.loginForm.get('password').value.length===0){
				this.mostrarErrorCamposObligatorios();
			}
			else{
				if(this.loginForm.get('email').valid === false){
					this.mostrarErrorCorreoInvalido();
				}
			}
		}
	}
	errorCount = 0;
	mostrarErrorLoginInvalido(){
		if (this.errorCount < 3) {
			this.toast.error('Tu correo o contraseña son incorrectos.','No pudimos iniciar tu sesion',{
				toastClass:'toast-erronea',
				timeOut:5000,
				positionClass:'toast-bottom-left',
			})
			this.errorCount++;
		}
		else if (this.errorCount === 3) {
			this.toast.error('Intenta ingresar de nuevo en 30 segundos', 'Has sobrepasado el limite de intentos', {
				toastClass: 'toast-erronea',
				timeOut: 30000,
				positionClass: 'toast-bottom-left',
				progressBar:true
			});
			this.errorCount++;
			this.btnDisabled = true;
			setTimeout(() => {
				this.btnDisabled = false;
				this.errorCount = 0;
			}, 30000); // Reiniciar el contador a 0 después de 5 segundos
		}
	}
	mostrarErrorCamposObligatorios() {
		if (this.errorCount < 3) {
			this.toast.error('Completalos e intentalo de nuevo', 'Estos campos son requeridos', {
				toastClass: 'toast-erronea',
				timeOut: 5000,
				positionClass: 'toast-bottom-left'
			});
			this.errorCount++;
		}
		else if (this.errorCount === 3) {
			this.btnDisabled = true;
			this.toast.error('Intenta ingresar de nuevo en 30 segundos', 'Has sobrepasado el limite de intentos', {
				toastClass: 'toast-erronea',
				timeOut: 30000,
				positionClass: 'toast-bottom-left',
				progressBar:true
			});
			this.errorCount++;
			setTimeout(() => {
				this.errorCount = 0;
				this.btnDisabled = false;
			}, 30000); // Reiniciar el contador a 0 después de 5 segundos
		}
	}
	mostrarErrorCorreoInvalido(){
		if (this.errorCount < 2) {
			this.toast.error('Revisa que tenga +3 caracteres, un "@" y un ".com"', 'Ingresa un correo valido ',{
				toastClass:'toast-erronea',
				timeOut:5000,
				positionClass:'toast-bottom-left'
			})
			this.errorCount++;
		}
		else if (this.errorCount === 2) {
			this.btnDisabled = true;
			this.toast.error('Intenta ingresar de nuevo en 30 segundos', 'Has sobrepasado el limite de intentos', {
				toastClass: 'toast-erronea',
				timeOut: 30000,
				positionClass: 'toast-bottom-left',
				progressBar:true
			});
			this.errorCount++;
			setTimeout(() => {
				this.errorCount = 0;
				this.btnDisabled = false;
			}, 30000); // Reiniciar el contador a 0 después de 5 segundos
		}
	}

	// Check if a form field is invalid and has been submitted
	invalid(campo: string): boolean {
		return this.loginForm.get(campo).invalid && this.formSubmitted;
	}
}
